import moment from "moment";
export { API_DATE } from "../Shared/formatters";
export { BASIS_OPTIONS, APPROVAL_STATUSES } from "../ShiftEarnings/shiftEarningsData";

// Leave earning types written by the attendance command and the APIs.
export const LEAVE_TYPES = ["Leave", "Paid Leave"];

export const emptyForm = () => ({ employee_code: "", date: moment().format("YYYY-MM-DD"), earning_type: "Paid Leave", shift_name: "", basis: "shift", quantity: "1", payment_factor: "1", rate: "", pay_schedule_id: "", status: "Pending" });

export const rowToForm = (row) => ({ employee_code: row.employee_code, employee_name: row.employee_name, image_url: row.image_url || "", department_name: row.department_name || row.department || "", designation: row.designation_name || row.designation || "", date: row.date, earning_type: row.earning_type, shift_name: row.shift_name || "", basis: row.basis, quantity: String(row.quantity ?? ""), payment_factor: String(row.payment_factor ?? ""), rate: String(row.rate ?? ""), pay_schedule_id: row.pay_schedule_id == null ? "" : String(row.pay_schedule_id), status: row.status, payable_amount: row.payable_amount });

// Same formula as the server: amount = quantity x rate x factor. A preview
// never replaces server amounts or enters the save payload.
export const previewLeaveEarning = (form, initial) => {
  if (initial && ["quantity", "payment_factor", "rate"].every((key) => form[key] === initial[key])) {
    return { payable_amount: initial.payable_amount };
  }
  return { payable_amount: (Number(form.quantity) || 0) * (Number(form.rate) || 0) * (Number(form.payment_factor) || 0) };
};

// `types`: the leave types from the server (useLeaveEarningTypes), or the
// built-in LEAVE_TYPES.
export const validateForm = (form, initial, types = LEAVE_TYPES) => {
  const errors = {};
  if (!form.employee_code.trim()) errors.employee_code = "Select an employee.";
  if (!moment(form.date, "YYYY-MM-DD", true).isValid()) errors.date = "Enter a valid date.";
  if (!types.includes(form.earning_type)) errors.earning_type = "Select a leave type.";
  if (!["shift", "hours"].includes(form.basis)) errors.basis = "Select a basis.";
  for (const key of ["quantity", "rate", "payment_factor"]) {
    if (String(form[key]).trim() === "" || !Number.isFinite(Number(form[key])) || Number(form[key]) < 0) errors[key] = "Enter a number of 0 or more.";
  }
  if (initial) Object.keys(errors).forEach((key) => { if (form[key] === initial[key]) delete errors[key]; });
  return errors;
};
